import * as z from "zod";

export const connectStayAiIntegration = {
  name: "connectStayAiIntegration" as const,
  /** Non-empty: disconnecting goes through disconnectStayAiIntegration. */
  input: z.object({ apiKey: z.string().min(1) }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
